import { render, staticRenderFns } from "./shopDispensing.vue?vue&type=template&id=1b924ffc&scoped=true"
import script from "./shopDispensing.vue?vue&type=script&lang=js"
export * from "./shopDispensing.vue?vue&type=script&lang=js"
import style0 from "./shopDispensing.vue?vue&type=style&index=0&id=1b924ffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b924ffc",
  null
  
)

export default component.exports